import LoadingModal from './src';

export default LoadingModal;
